import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { AccountWithContraAccount } from "@models/account-with-contra-account.model";
import { Configuration } from "@models/configuration.model";
import { Disbursement } from "@models/disbursement.model";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  constructor(private readonly http: HttpClient) {}

  getAccountsForClient$(
    clientId: string
  ): Observable<AccountWithContraAccount[]> {
    return this.http.get<AccountWithContraAccount[]>(
      `${environment.BASE_URL}client/${clientId}/gfhaccount`
    );
  }

  getAccountConfiguration$(): Observable<Configuration> {
    return this.http.get<Configuration>(
      `${environment.BASE_URL}modzconfig/switches`
    );
  }

  getDisbursements$(gfhAccountId: string): Observable<Disbursement[]> {
    return this.http
      .get<{
        disbursement: Disbursement[];
      }>(
        `${environment.BASE_URL}gfhaccount/${gfhAccountId}/gfhtransaction/disbursements?skip=0&take=5`
      )
      .pipe(map((response): Disbursement[] => response.disbursement));
  }
}
